import { useTranslation } from 'react-i18next';
import { useCustomFieldsForms } from '../../../../../../hooks/useCustomFieldsForm';
import useReconfirmationExamDrawerFieldsConfig from './useReconfirmationExamDrawerFieldsConfig';
import useTranslate from '../../../../../../hooks/useTranslate';

export interface ReconfirmationExamDrawerFormData {
    examName: string;
}

export const INITIAL_VALUES: ReconfirmationExamDrawerFormData = {
    examName: '',
};

type ReconfirmationExamDrawerFieldsConfig = ReturnType<
    typeof useReconfirmationExamDrawerFieldsConfig
>['fieldsConfig'];

const useReconfirmationExamDrawerForm = () => {
    const { t } = useTranslation('periodicos');
    const { translate } = useTranslate(t);

    return useCustomFieldsForms<
        ReconfirmationExamDrawerFormData,
        ReconfirmationExamDrawerFieldsConfig
    >({
        translate: translate,
        initialValues: INITIAL_VALUES,
        useFieldsConfig: useReconfirmationExamDrawerFieldsConfig
    });
};

export default useReconfirmationExamDrawerForm;
